export const MEXICAN_STATES = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de México",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas",
] as const;

export type MexicanState = (typeof MEXICAN_STATES)[number];

export function buildCafeAddress(parts: {
  calle?: string | null;
  numero_exterior?: string | null;
  colonia?: string | null;
  codigo_postal?: string | null;
  city?: string | null;
  estado?: string | null;
  location?: string | null;
}): string {
  const street = [parts.calle, parts.numero_exterior].filter(Boolean).join(" ").trim();
  const cpCity = [parts.codigo_postal, parts.city].filter(Boolean).join(" ").trim();
  const segments = [
    street,
    parts.colonia ?? undefined,
    cpCity || undefined,
    parts.estado ?? undefined,
    "México",
  ].filter((s): s is string => !!s && s.length > 0);

  // If we have at least street + something else, use the structured address.
  if (street && segments.length >= 3) return segments.join(", ");

  // Fallback to legacy combined `location` field.
  const fallback = [parts.location, parts.city, parts.estado, "México"]
    .filter((s): s is string => !!s && s.length > 0)
    .join(", ");
  return fallback || segments.join(", ");
}
